<template>
  <div>
    <div class="detail">
      <div class="text-center title">{{ content.title }}</div>
      <audio v-if="content.postType === 2" :src="content.video" controls="controls">
        Your browser does not support the audio element.
      </audio>
      <div class="text-center" v-if="content.postType === 1">
        <video :src="content.video" controls="controls">
          Your browser does not support the video element.
        </video>
      </div>
      <div v-if="content.postType === 1 || content.postType === 2">{{ content.summary }}</div>
      <div v-else v-html="content.content" />
    </div>
    <div class="text-center investigate">
      <template v-if="isInvestigate">
        <div class="text">这条帮助是否解决了您的问题？</div>
        <div class="btns">
          <a @click="investigate(true)">已解决</a>
          <a @click="investigate(false)">未解决</a>
        </div>
      </template>
      <div v-else class="text">感谢您的意见</div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "./style.scss";
</style>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Detail',
  data() {
    return {
      id: 0,
      content: {},
      isInvestigate: true,
    };
  },
  computed: {
    ...mapState({
      listId: state => state.app.listId,
      menuOpenId: state => state.app.menuOpenId,
    }),
  },
  created() {
    const {
      params: { detailId },
    } = this.$route;

    this.id = detailId;

    // 检查地址栏路由是否为管理tab下
    if (window.location.pathname.includes('/2/')) {
      // 包含 /2/ 格式的为管理tab路由
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
      ) {
        // 移动端设备
        this.$router.push({ name: 'adapterDetails', query: { id: this.id } });
      } else {
        // PC端设备
      }
    }

    // 详情
    this.$store
      .dispatch('detail/getDetail', {
        id: detailId,
      })
      .then((data) => {
        const {
          title, parentQlwId, parentColumnId, parentColumnName,
        } = data;
        if (data) {
          this.content = data;
          this.$store.commit('app/setListId', parentColumnId);
          this.$store.commit('app/setMenuOpenId', parentColumnId);
          // sub = sub.replace(/href='/, "href='http://qlw.t.nxin.com");
          this.content.content = this.content.content.replace(
            /<img/g,
            "<img preview='0' title='点击查看大图' class='click'",
          );
          document.title = `农信互联-帮助中心-${title}`;
        }
        this.$previewRefresh();
        // 获取分类
        this.$store
          .dispatch('list/getHelpList', {
            qlw_id: parentQlwId,
            pageNum: 1,
            pageSize: 19,
            column_name: parentColumnName,
            concludeImage: true,
          })
          .then((classData) => {
            this.$store.commit('app/setClassList', classData.list);
          });
      });
  },
  methods: {
    investigate(isUsefulness) {
      this.$store
        .dispatch('detail/putInvestigate', {
          id: this.id,
          resolved: isUsefulness,
        })
        .then((data) => {
          if (data.code === 0) {
            this.isInvestigate = false;
          }
        });
    },
  },
};
</script>
